import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentSubdomain: null,
  previousSubdomain: null,
  subdomainChangeTimestamp: null
};

export const subdomainSlice = createSlice({
  name: 'subdomain',
  initialState,
  reducers: {
    setCurrentSubdomain: (state, action) => {
      // If the subdomain is changing, store the previous one
      if (state.currentSubdomain !== action.payload && state.currentSubdomain !== null) {
        state.previousSubdomain = state.currentSubdomain;
        state.subdomainChangeTimestamp = Date.now();
      }
      state.currentSubdomain = action.payload;
    },
    clearPreviousSubdomain: (state) => {
      state.previousSubdomain = null;
      state.subdomainChangeTimestamp = null;
    }
  }
});

export const { setCurrentSubdomain, clearPreviousSubdomain } = subdomainSlice.actions;

export default subdomainSlice.reducer; 